import React from 'react';
import { PropTypes } from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import Button from 'components/Common/Buttons';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import { history } from 'containers/App';

import { clearPreQualQuestionnaire } from 'actions/questionnaires';

const Home = ({ usePreQualifyingQuestionnaire, defaultFormUrl, dispatch }) => {
  const startNewPQQuestionnaire = () => {
    dispatch(clearPreQualQuestionnaire());
    history.push('/pre-qualifying-questionnaire');
  };

  const intl = useIntl();
  return (
    usePreQualifyingQuestionnaire ? <section>
      <div className="pre-questionnaire-landing col-12 col-lg-10 col-xl-8">
        <div className="welcome-card">
          <h1><LocalisedMessage id="preQualifyingQuestionnaire.welcome" /></h1>
          <div className="welcome-text">
            <p><LocalisedMessage id="preQualifyingQuestionnaire.content" /></p>
          </div>
          <Button className="btn-primary" value={ intl.formatMessage({ id: 'preQualifyingQuestionnaire.start' }) } onClick={ startNewPQQuestionnaire } />
          <p className="mt-4"><LocalisedMessage id="preQualifyingQuestionnaire.manualFormSelectText" /></p>
          <Link to="/form-selection" className="btn btn-link"><LocalisedMessage id="preQualifyingQuestionnaire.manualFormSelectLinkText" /></Link>
        </div>
      </div>
    </section> : <Redirect to={ defaultFormUrl ?? '/form-selection' } />
  );
};

Home.propTypes = {
  usePreQualifyingQuestionnaire: PropTypes.bool,
  defaultFormUrl: PropTypes.string,
  dispatch: PropTypes.func.isRequired
};

Home.defaultProps = {
  usePreQualifyingQuestionnaire: false,
  defaultFormUrl: null
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: { onlineConfig }
  } = state;

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
    defaultFormUrl: onlineConfig && onlineConfig.defaultFormUrl
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
